import { EMPTY_STATE_TEST_IDS } from 'modules/dataDictionary/constants';
import { EmptyStateConfig } from 'modules/dataDictionary/types';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { Spinner } from 'ui/spinner';
import { colors, spacing } from 'ui/theme';

export const StyledEmptyState = styled(EmptyState)`
  min-height: ${spacing.x32};
  justify-content: center;
  padding: ${spacing.double};
  background-color: ${colors.backgroundPrimary};
`;

export const StyledSpinner = styled(Spinner)`
  min-height: ${spacing.x32};
  justify-content: center;
  padding: ${spacing.double};
`;

/**
 * Table Body
 * Component used to return either empty states or pass through children
 */
type TableBodyProps = {
  children: ReactNode;
  currentCount: number;
  emptyStateConfig: EmptyStateConfig;
  hasError?: boolean;
  isLoading: boolean;
  totalCount: number;
};

export const TableBody = ({
  children,
  currentCount,
  emptyStateConfig,
  hasError,
  isLoading,
  totalCount,
}: TableBodyProps) => {
  if (isLoading) {
    return <StyledSpinner />;
  }

  if (hasError && emptyStateConfig?.error) {
    return (
      <StyledEmptyState
        data-test={EMPTY_STATE_TEST_IDS.error}
        Illustration={emptyStateConfig?.error?.Illustration}
        subtitle={emptyStateConfig?.error?.subtitle}
        title={emptyStateConfig?.error?.title}
      />
    );
  }

  if (totalCount === 0) {
    return (
      <StyledEmptyState
        data-test={EMPTY_STATE_TEST_IDS.empty}
        Illustration={emptyStateConfig.empty.Illustration}
        subtitle={emptyStateConfig.empty.subtitle}
        title={emptyStateConfig.empty.title}
      />
    );
  }

  if (currentCount === 0) {
    return (
      <StyledEmptyState
        data-test={EMPTY_STATE_TEST_IDS.noResults}
        Illustration={emptyStateConfig.noResults.Illustration}
        subtitle={emptyStateConfig.noResults.subtitle}
        title={emptyStateConfig.noResults.title}
      />
    );
  }

  return <>{children}</>;
};
